// extracted by mini-css-extract-plugin
export default {"loginLayout":"LoginPage_loginLayout__RC5ti","logoBlock":"LoginPage_logoBlock__wXpWQ","imageLogo":"LoginPage_imageLogo__lCy5e"};